import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'transformStatus'
})
export class TransformStatus implements PipeTransform {
    transform(input: any): any {
        switch (input) {
            case "PENDING":
                input = "PENDIENTE";
                break;
            case "COMPLETED":
                input = "COMPLETADO";
                break;
            case "FAILED":
                input = "NO APROBADO";
                break;
            case "APPROVED":
                input = "APROBADO";
                break;
            case "IN_PROCESS":
                input = "EN PROCESO";
                break;
            case "PROCESSED":
                input = "PROCESADO";
                break;
            case "VALIDATED":
                input = "VALIDADO";
                break;
            case "REJECTED":
                input = "RECHAZADO";
                break;
        }
        return input;
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/pipes/string/transformStatus.pipe.ts